import type { SVGProps } from 'react';
export const AddQuantity = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M17 9.73q0 1.65-.94 2.69l.82.9-.68.68-.89-.98q-.78.45-1.77.44a3.3 3.3 0 0 1-2.52-1.02 3.8 3.8 0 0 1-.96-2.71q0-1.68.96-2.7A3.3 3.3 0 0 1 13.54 6q1.56 0 2.51 1.02t.95 2.7m-3.46 2.54q.5 0 .91-.2l-.8-.9.7-.67.83.93q.45-.68.45-1.7 0-1.17-.56-1.86a1.9 1.9 0 0 0-1.53-.68 1.9 1.9 0 0 0-1.52.68 2.8 2.8 0 0 0-.58 1.86q0 1.17.58 1.85.57.69 1.52.69" />
    <path
      fillRule="evenodd"
      d="M5.73 7.48c.15 0 .27.13.27.28v2.26h2.2c.14 0 .26.12.26.27s-.12.27-.26.27H6v2.27c0 .15-.12.27-.27.27a.3.3 0 0 1-.26-.27v-2.27h-2.2A.27.27 0 0 1 3 10.3c0-.15.12-.27.26-.27h2.2V7.76c0-.15.13-.28.27-.28"
      clipRule="evenodd"
    />
  </svg>
);
